export default __webpack_public_path__ + "images/25510c44bb409fc83ce6b2770aba1e36-body-awareness.svg";